module.exports = __webpack_public_path__ + "img/avon.6194bebc.svg";